import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import TooltipEnclosure from '../../../../components/TooltipEnclosure';
import ColoredDot from '../../../../components/ColoredDot';
import { getAlgoListDataCachedSelectedDay } from '../../../../stores/algos-list/getters';
import { healthStatuses } from '../../../../data/health-status-data-algo-edit';

const useStyles = makeStyles(() => ({
  root: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const Dot = ({ id }) => {
  const algoStatus = useSelector((state) => {
    const { algoStatus = 'GREY' } =
      getAlgoListDataCachedSelectedDay(state).find((d) => d._id === id) || {};

    return algoStatus;
  });

  const { color: statusColor = '' } = healthStatuses[algoStatus]
    ? healthStatuses[algoStatus]
    : {};

  const color = statusColor ? statusColor.toLowerCase() : '';

  let tooltip = 'Algo status: Unavailable';

  if (algoStatus === 'RUNNING' || algoStatus === 'GREEN') {
    tooltip = 'Algo is running';
  } else if (algoStatus === 'NOT_RUNNING' || algoStatus === 'RED') {
    tooltip = 'Algo is not running';
  } else if (algoStatus === 'ORANGE') {
    tooltip = 'Algo is partially running';
  }

  return (
    <TooltipEnclosure title={tooltip}>
      <ColoredDot color={color} />
    </TooltipEnclosure>
  );
};

const CellAlgoStatus = ({ row = {} }) => {
  const classes = useStyles();
  const { original = {} } = row;
  const { _id = '' } = original;

  return (
    <div className={classes.root}>
      <Dot id={_id} />
    </div>
  );
};

export default CellAlgoStatus;
